export class Rates {
	constructor(obj) {
		if (!obj) return;

		this.public_holidays = obj.public_holidays;
		this.saturday = obj.saturday;
		this.sundays = obj.sundays;
		this.weekdays = obj.weekdays;
	}
}

export default Rates;
